const licenses = {
    na: "Not Applicable",
    unknown: "Unknown",
    cc_pdm: "CC Public Domain",
    cc_by_sa: "CC Share A like",
    cc_by_nd: "CC No Derivatives",
    cc_by_nc: "CC Non-Commercial",
    cc_by_nc_nd: "CC Non-Commercial / No Derivatives",
    trademarked: "Trademarked",
    patented: "Patenened"
}

export default licenses
